
    <select
      [disabled]="disabled"
      class="custom-select"
      [value]="date?.month"
      (change)="changeMonth($event.target.value)"
      tabindex="-1">
        <option *ngFor="let m of months" [value]="m">{{ i18n.getMonthShortName(m) }}</option>
    </select><select
      [disabled]="disabled"
      class="custom-select"
      [value]="date?.year"
      (change)="changeYear($event.target.value)"
      tabindex="-1">
        <option *ngFor="let y of years" [value]="y">{{ y }}</option>
    </select>
  


// WEBPACK FOOTER //
// ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation-select.d.ts.NgbDatepickerNavigationSelect.html